import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { useDataValue } from 'Simple/Data.js'
import View from './view.js'
import { useOnMoveBoard, useOnReorderBoard } from '../../helpers.js'

let ITEM_TYPE = 'BOARD_ITEM'

function DraggableBoardItem({
  board,
  index,
  list_type,
  boards,
  onMove,
  onReorder,
  ...props
}) {
  let ref = useRef(null)

  // Drop zone for accepting dragged items
  let [{ isActive }, drop] = useDrop({
    accept: ITEM_TYPE,
    collect: monitor => ({
      isActive: monitor.canDrop() && monitor.isOver(),
    }),
    hover(draggedItem) {
      // Same-list reordering
      if (draggedItem.list_type === list_type && draggedItem.index !== index) {
        if (typeof onReorder === 'function') {
          onReorder(draggedItem.index, index)
        }
        draggedItem.index = index
      }
    },
    drop(draggedItem) {
      // Cross-list move
      if (draggedItem.list_type !== list_type) {
        if (typeof onMove === 'function') {
          onMove(
            draggedItem.board_id,
            draggedItem.list_type,
            list_type,
            index,
            draggedItem.sourceBoards || [],
            boards || []
          )
        }
      }
    },
  })

  // Drag source
  let [{ isDragging }, drag] = useDrag({
    type: ITEM_TYPE,
    item: {
      board_id: board.id,
      list_type,
      index,
      sourceBoards: boards,
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  drag(drop(ref))

  return (
    <View
      {...props}
      innerRef={ref}
      isDragging={isDragging}
      isActive={isActive}
    />
  )
}

export default function Logic(props) {
  let board = useDataValue({
    context: 'board',
    viewPath: props.viewPath,
  })

  let list_type = useDataValue({
    context: 'task_boards_list',
    path: 'type',
    viewPath: props.viewPath,
  })

  let boards = useDataValue({
    context: 'boards',
    path: 'boards',
    viewPath: props.viewPath,
  })

  let onMove = useOnMoveBoard(props)
  let onReorder = useOnReorderBoard(props)

  // Skip drag-drop for private boards
  if (list_type === 'private') {
    return <View {...props} />
  }

  let index = boards?.findIndex(b => b.id === board.id) ?? 0

  return (
    <DraggableBoardItem
      {...props}
      board={board}
      list_type={list_type}
      index={index}
      boards={boards}
      onMove={onMove}
      onReorder={onReorder}
    />
  )
}
